class CSVReportForm {
  constructor(){
    this._classes = {
      requestResultSuccess: 'request-result__success',
      requestResultFailure: 'request-result__failure',
      visible: '--visible'
    };

    this._form = null;
    this._requestResultSuccess = null;
    this._requestResultFailure = null;
  }

  init(){
    this._form = document.forms['report-form'];

    if(this._form) {
      this._form.addEventListener('submit', this._handleSubmit.bind(this));
      this._requestResultSuccess = document.querySelector(`.${this._classes.requestResultSuccess}`);
      this._requestResultFailure = document.querySelector(`.${this._classes.requestResultFailure}`);
    }
  }

  /**
   * Handle form submission: prevent normal process & fetch manually
   *
   * @param {Event} event - Form submit event
   */
  async _handleSubmit(event){
    if(event && event.target){
      event.preventDefault();
      this._resetRequestResults();

      let isRequestSuccess = false;
      try{
        const init = {
          method: 'POST',
          body: new FormData(event.target)
        };

        const response = await fetch(event.target.action, init);

        if(response && response.status === 200) {
          isRequestSuccess = true;
        }
      }
      finally {
        this._showRequestResult(isRequestSuccess);
      }
    }
  }

  /**
   * Show result message
   *
   * @param {boolean} isRequestSuccess - Request success indicator
   */
  _showRequestResult(isRequestSuccess){
    const resultToShow = isRequestSuccess ?
    this._requestResultSuccess :
    this._requestResultFailure;

    resultToShow.className += ` ${resultToShow.className}${this._classes.visible}`;
  }

  /**
   * Reset result message classes
   */
  _resetRequestResults(){
    this._requestResultSuccess.className = this._classes.requestResultSuccess;
    this._requestResultFailure.className = this._classes.requestResultFailure;
  }
}

export default CSVReportForm;
